// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"e4","newsTag":"e4","dafalut":"e5","shehui":"e6","caiwu":"e7","keji":"e8","lingshou":"e9","gongzuo":"e-"};